import { Marquee } from "./Marquee";
import { SOURCE_FALLBACK, type Source } from "@/features/discovery";

export function LiveTicker({
    sources = SOURCE_FALLBACK,
}: {
    sources?: Source[];
}) {
    const items = sources.length ? sources : SOURCE_FALLBACK;

    return (
        <div className="flex flex-row items-center gap-3 py-1 sm:gap-4">
            <span className="inline-flex shrink-0 items-center gap-3">
                {/* oxlint-disable-next-line shadcn/no-arbitrary-values -- 12.5px falls between text-caption (11px) and text-body-small (13px) */}
                <span className="font-family-body text-[12.5px] font-semibold text-doberman-black/70">
                    <span className="sm:hidden">21,000 sources</span>
                    <span className="hidden sm:inline">
                        Live from 21,000 sources
                    </span>
                </span>
                <span className="hidden h-4 w-px bg-doberman-black/15 sm:block" />
            </span>
            <div className="min-w-0 flex-1">
                <Marquee
                    items={items}
                    itemKey={(s) => s.name}

                    durationSec={180}
                    renderItem={(s, isClone) => (
                        <span
                            aria-hidden={isClone}
                            className="flex shrink-0 items-center gap-2 pr-8"
                        >
                            <span className="text-body-small text-doberman-black/70">
                                {s.name}
                            </span>
                            <span className="text-body-small text-doberman-black/45">
                                {s.dogs.toLocaleString()} dogs
                            </span>
                        </span>
                    )}
                />
            </div>
        </div>
    );
}
